var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AllRecordsTable',{attrs:{"submit-button-text":"Добавить календарь смен","table-name":"shifts_calendars","link-slug":"shifts_calendars","title":"Календари смен","columns":_vm.table.columnNames,"rows":_vm.table.rowNames,"filter-fields":_vm.table.filterFields,"order-fields":_vm.orderFields}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430309b5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/user/pages/AllShiftsCalendarsPage.vue
// module id = null
// module chunks = 